// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__lBQuo","calendarButtons":"ClockData_calendarButtons__3RtNv"};